import { BubbleChat } from 'flowise-embed-react'

const Chatbot = () => {
    return (
        <BubbleChat
            chatflowid="b7068d86-f26b-458f-b233-a4e42e91328a"
            apiHost="https://flowise.atende24h.com.br"
        />
    );
};
export default Chatbot;